/**
 * Haritadan konum (enlem/boylam) seçimi için modal
 * Leaflet CDN ile yüklenir (window.L)
 */
import React, { useEffect, useRef, useState } from 'react';

const DEFAULT_LAT = 39.9334;
const DEFAULT_LNG = 32.8597;

const MapPickerModal = ({ isOpen, onClose, onSelect, initialLat, initialLng }) => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markerRef = useRef(null);
  const [lat, setLat] = useState(initialLat ?? DEFAULT_LAT);
  const [lng, setLng] = useState(initialLng ?? DEFAULT_LNG);

  useEffect(() => {
    if (!isOpen || typeof window === 'undefined' || !window.L) return;
    if (!mapRef.current) return;

    const L = window.L;
    const initLat = initialLat != null && !Number.isNaN(Number(initialLat)) ? Number(initialLat) : DEFAULT_LAT;
    const initLng = initialLng != null && !Number.isNaN(Number(initialLng)) ? Number(initialLng) : DEFAULT_LNG;
    const map = L.map(mapRef.current).setView([initLat, initLng], 13);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap',
    }).addTo(map);

    const marker = L.marker([initLat, initLng], { draggable: true }).addTo(map);
    marker.on('dragend', () => {
      const pos = marker.getLatLng();
      setLat(pos.lat);
      setLng(pos.lng);
    });

    map.on('click', (e) => {
      marker.setLatLng(e.latlng);
      setLat(e.latlng.lat);
      setLng(e.latlng.lng);
    });

    mapInstanceRef.current = map;
    markerRef.current = marker;

    return () => {
      map.remove();
      mapInstanceRef.current = null;
      markerRef.current = null;
    };
  }, [isOpen, initialLat, initialLng]);

  useEffect(() => {
    if (isOpen) {
      const initLat = initialLat != null && !Number.isNaN(Number(initialLat)) ? Number(initialLat) : DEFAULT_LAT;
      const initLng = initialLng != null && !Number.isNaN(Number(initialLng)) ? Number(initialLng) : DEFAULT_LNG;
      setLat(initLat);
      setLng(initLng);
    }
  }, [isOpen, initialLat, initialLng]);

  const handleConfirm = () => {
    onSelect({ latitude: lat, longitude: lng });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '20px',
          width: '90%',
          maxWidth: '600px',
          maxHeight: '90vh',
          overflow: 'auto',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3 style={{ marginBottom: '12px' }}>Konum Seç (Haritadan tıklayın veya işareti sürükleyin)</h3>
        <div
          ref={mapRef}
          style={{ width: '100%', height: '350px', borderRadius: '8px', marginBottom: '16px' }}
        />
        <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
          <label>
            Enlem
            <input
              type="number"
              step="any"
              value={lat}
              onChange={(e) => setLat(parseFloat(e.target.value) || DEFAULT_LAT)}
              style={{ marginLeft: '8px', padding: '6px', width: '120px' }}
            />
          </label>
          <label>
            Boylam
            <input
              type="number"
              step="any"
              value={lng}
              onChange={(e) => setLng(parseFloat(e.target.value) || DEFAULT_LNG)}
              style={{ marginLeft: '8px', padding: '6px', width: '120px' }}
            />
          </label>
        </div>
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <button type="button" className="category-action-btn" onClick={onClose}>
            İptal
          </button>
          <button type="button" className="category-action-btn edit-btn" onClick={handleConfirm}>
            Seç
          </button>
        </div>
      </div>
    </div>
  );
};

export default MapPickerModal;
